module.exports = __webpack_public_path__ + "assets/icons/ic_arrow_drop_up_24px.svg";